module.exports = __webpack_public_path__ + "img/authors-by-vuln.b7bbaac2.png";